import Phaser from 'phaser';

const createHeroAnims = (anims: Phaser.Animations.AnimationManager) => {
	anims.create({
		key: 'hero-move',
		frameRate: 10,
		frames: anims.generateFrameNames('kebab_tiles', { prefix: 'hero', suffix: '.png', start: 1, end: 3 }),
		repeat: -1
	});

	anims.create({
		key: 'hero-idle',
		frames: [{ key: 'kebab_tiles', frame: 'hero2.png' }]
	});

	anims.create({
		key: 'hero-die',
		frameRate: 10,
		frames: anims.generateFrameNames('kebab_tiles', { prefix: 'sprite_tiles-', suffix: '.png', start: 81, end: 91 }),

	});
};

export default createHeroAnims;

export {
	createHeroAnims
};
